import { getBalanceRequest } from 'features/app/api';
import { useQuery } from 'react-query';

export const usePartnerBalanceQuery = () => {
  const result = useQuery(
    `partner-balance`,
    async () => {
      const { data } = await getBalanceRequest();
      return data;
    },
    { staleTime: Infinity }
  );

  return result;
};
